// extracted by mini-css-extract-plugin
export var carrierTab = "_55-0";
export var carrierTabActive = "_55-1 _55-0";
export var carrierTabInactive = "_55-2 _55-0";
export var carrierTabLabel = "_55-3";
export var carrierTabLabelActive = "_55-4 _55-3";
export var carrierTabLabelInactive = "_55-5 _55-3";
export var carrierTabPercentage = "_55-6";
export var carrierTabPercentageActive = "_55-7 _55-6";
export var carrierTabPercentageInactive = "_55-8 _55-6";
export var carrierTabWinnable = "_55-9";
export var carrierTabWinnableActive = "_55-a _55-9";
export var carrierTabWinnableInactive = "_55-b _55-9";
export var comparisonContainer = "_55-d";
export var missingRateButton = "_55-n";
export var missingRateButtonActive = "_55-o _55-n";
export var missingRateButtonInactive = "_55-p _55-n";
export var missingRateButtonLabel = "_55-q";
export var missingRateButtonLabelActive = "_55-r _55-q";
export var missingRateButtonLabelInactive = "_55-s _55-q";
export var sidebar = "_55-c";
export var strategyButton = "_55-e";
export var strategyButtonActive = "_55-f _55-e";
export var strategyButtonDescription = "_55-k";
export var strategyButtonDescriptionActive = "_55-l _55-k";
export var strategyButtonDescriptionInactive = "_55-m _55-k";
export var strategyButtonInactive = "_55-g _55-e";
export var strategyButtonLabel = "_55-h";
export var strategyButtonLabelActive = "_55-i _55-h";
export var strategyButtonLabelInactive = "_55-j _55-h";
export var unitToggleButton = "_55-t";
export var unitToggleButtonActive = "_55-u _55-t";
export var unitToggleButtonInactive = "_55-v _55-t";
export var unitToggleButtonLabel = "_55-w";
export var unitToggleButtonLabelActive = "_55-x _55-w";
export var unitToggleButtonLabelInactive = "_55-y _55-w";